import { Box, ScrollArea, Text, Skeleton } from "@mantine/core";
import { stripHtml } from "../../../../../../utils";
import { getOriginalItemViewLabel } from "../../../../../../utils/evidence/businessCategoryOriginalLabels";

const CallTextArea = ({
  title,
  text,
  mlData,
  excerptsArr,
  setOpened,
  type,
  isLoadingMl = false,
  originalItemLinkLabel,
}: {
  title: string;
  text: string;
  mlData: any;
  excerptsArr: any[];
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
  type: string;
  isLoadingMl?: boolean;
  /** When set, overrides type-based default (businessCategory-driven copy). */
  originalItemLinkLabel?: string;
}) => {
  const linkLabelFromType = () => {
    if (type === 'call') return getOriginalItemViewLabel('call');
    if (type === 'notes') return getOriginalItemViewLabel('customerInterview');
    if (type === 'conversation') return getOriginalItemViewLabel('chat');
    if (type === 'survey') return getOriginalItemViewLabel('survey');
    return 'View';
  };
  const linkText = (originalItemLinkLabel?.trim() || linkLabelFromType());

  
  return (
    <>
      {title && (
        <Text fz={14} fw={600} lineClamp={1} mb={14} lh={"18px"}>
          {title}
        </Text>
      )}
      <ScrollArea mt={15}>
        {text && (
          <Box
            py={8}
            px={12}
            bg="#F8F9FA"
            sx={{ borderLeft: "2px solid rgba(92, 92, 235, 0.6)" }}
          >
            <Text
              fz={14}
              lh={"18px"}
              color="#212529"
              sx={{
                whiteSpace: "pre-line",
              }}
            > 
              {
                isLoadingMl ? (
                  <div>
                    <Skeleton height={14} width="100%" mb={8} />
                    <Skeleton height={14} width="95%" mb={8} />
                    <Skeleton height={14} width="85%" />
                  </div>
                ) : mlData?.functionalitySummary ? (
                  <div>
                    <b>Gap/Request: </b>
                    {stripHtml(mlData?.functionalitySummary)}
                    <br /><br />
                    <b>Underlying need: </b>
                    {stripHtml(mlData?.functionalityGap)}
                  </div>
                ) : stripHtml(text)
              }
            </Text>
          </Box>
        )}
        {excerptsArr && excerptsArr.length > 0 && (
          <Box
            py={8}
            px={12}
            bg="#F8F9FA"
            sx={{ borderLeft: "2px solid rgba(92, 92, 235, 0.6)" }}
          >
            <Text
              mb="5px"
              fw={600}
              style={{ color: "black", fontSize: "14px" }}
            >
              {excerptsArr.length === 1 ? "Excerpt:" : "Excerpts:"}
            </Text>
            <div>
              {excerptsArr.map((excerptItem: any, index: number) => (
                <Box key={index}>
                  <Text color="#585C68"
                    fz={13.6} lh={"18px"} my={1}>
                    {excerptItem.fullQuote?.includes(':') ? excerptItem.fullQuote.split(':')[0] + ':' : ''}
                  </Text>
                  <Text
                    color="#585C68"
                    fz={14}
                    lh={"18px"}
                    sx={{
                      whiteSpace: "pre-line",
                      position: "relative",
                      "&::after": {
                        content: "'...'",
                        display: "inline",
                        paddingLeft: "4px",
                      },
                      "&::before": {
                        content: "'...'",
                        display: "inline",
                        paddingLeft: "4px",
                      },
                    }}
                  >
                    {excerptItem?.excerpt || "N/A"}
                  </Text>
                </Box>
              ))}
            </div>
          </Box>
        )}
      </ScrollArea>
      {
        <Box
          w="100%"
          py={8}
          px={12}
          bg="#F8F9FA"
          sx={{ borderLeft: "2px solid rgba(92, 92, 235, 0.6)" }}
        >
          <Text
            mt={10}
            fz={13}
            color="#5C5CEB"
            sx={{
              cursor: "pointer",
            }}
            onClick={() => setOpened(true)}
          >
            {linkText}
          </Text>
        </Box>
      }
    </>
  );
};

export default CallTextArea;
